import React, { useState } from 'react'
import RyderLivescoringTeamDefaultView from "@/components/RyderLivescoring/views/default/RyderLivescoringTeamDefaultView"
import RyderLivescoringTeamNin9rsView from "@/components/RyderLivescoring/views/nin9rs/RyderLivescoringTeamNin9rsView"

const RyderLivescoringTeam = ({
    players,
    teamColor,
    isWinner,
    isDraw,
    result,
    tbd,
    match = {},
    side = {},
    isRight = false,
    customDesign
}) => {
    const [modalUrl, setModalUrl] = useState(null)

    const showResult = isWinner || isDraw

    const holeInProgress = function (match) {
        let response = "Upcoming"

        if (match.tee) {
            response += " - Tee " + match.tee
        }

        let result = match.result
        let holeInProgress = match.holeInProgress

        if (match.finalized || (result && !holeInProgress)) {
            response = "Final"
        } else if (holeInProgress) {
            return "Hole " + holeInProgress
        }

        return response
    }

    const getUrlFromDOM = (sideId) => {
        sideId = Number(sideId)

        const el = document.getElementById('tarjetas-data')
        if (!el) return null

        try {
            const data = JSON.parse(el.dataset.tokens)
            const urls = {}

            data.forEach(item => urls[item.sideId] = item.url)

            return urls[sideId] || null
        } catch (e) {
            return null
        }
    }

    const showElectronicCard = (side) => {
        const url = getUrlFromDOM(side.id)

        if (url) {
            setModalUrl(url)
        } else {
            toast('No se encontró la tarjeta electrónica.', 'info')

            setTimeout(function () {
                fetch(window.location.href, {
                    headers: {
                        'autoreload': '1'
                    }
                }).then(function () {
                    window.location.reload()
                })
            }, 3000)
        }
    }

    if ("nin9rs" === customDesign) {
        return <RyderLivescoringTeamNin9rsView
            tbd={tbd}
            isRight={isRight}
            teamColor={teamColor}
            showElectronicCard={showElectronicCard}
            side={side}
            players={players}
            showResult={showResult}
            result={result}
            holeInProgress={holeInProgress}
            match={match}
            modalUrl={modalUrl}
            setModalUrl={setModalUrl}
        />
    } else {
        return <RyderLivescoringTeamDefaultView
            tbd={tbd}
            isRight={isRight}
            isWinner={isWinner}
            teamColor={teamColor}
            showElectronicCard={showElectronicCard}
            side={side}
            players={players}
            showResult={showResult}
            isDraw={isDraw}
            result={result}
            holeInProgress={holeInProgress}
            match={match}
            modalUrl={modalUrl}
            setModalUrl={setModalUrl}
        />
    }
}

export default RyderLivescoringTeam
